/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Unlimited_CreditInputs */

const vi_customer_unlimited_credit = /** @type {(inputs: Customer_Unlimited_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không giới hạn`)
};

/**

* @param {Customer_Unlimited_CreditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_unlimited_credit = /** @type {((inputs?: Customer_Unlimited_CreditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Unlimited_CreditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_unlimited_credit(inputs)
});